import { request } from '@/utils'

export default {

  // 获取研究中心列表
  async findResearchCenter() {
    return request({
      path: '/researchCenter',
      query: {
        page: 1,
        limit: 99999
      }
    })
  },

  async findOneCenter({ id }) {
    return request({
      path: `/researchCenter/${id}`,
    })
  },
}



// WEBPACK FOOTER //
// ./src/api/center.js